/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { memo, useEffect, useRef } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useStateMachine } from "little-state-machine";

import ReactLoading from 'react-loading';
import { loadingCss } from "assets/css/shchMtmr";

import { getStore, mtgCallbackUpdateAction } from "stores/actions";

import useGetLazyQuery from "hooks/useGetLazyQuery";
import { GET_MEMBER_INFO } from "graphql/query";

import { formatTelNumber } from "utilities/formater";

/**
 * お客さま確認画面　MTGコールバック
 */
const ContractMtgCallback = memo(() => {
  const navigate = useNavigate();

  // MTGログイン情報取得用カスタムフック
  const [getMemberInfo, loading] = useGetLazyQuery(GET_MEMBER_INFO);

  const [searchParams] = useSearchParams();

  // store取得
  const { state } = useStateMachine(getStore);

  // store更新
  const { actions } = useStateMachine({
    mtgCallbackUpdateAction,
  });

  const name = "mtgLoginSelect";

  const redirectState = searchParams.get("state");
  const redirectCode = searchParams.get("code");
  const oidcState = sessionStorage.getItem("oidcState");

  /**
   * 住所を連結して返却
   */
  const getFullAddress = (address, bant, go, bldName, muneban, heyaban) => {
    return [
      address,
      go ? bant + "-" + go : bant,
      bldName,
      muneban,
      heyaban,
    ].join(" ");
  };

  const refFirstRef = useRef(true);

  useEffect(() => {

    if (process.env.NODE_ENV === "development") {
      if (refFirstRef.current) {
        refFirstRef.current = false;
        return;
      }
    }

    let memberInfoList = [];

    // 会員情報が存在する場合、mTG連携は行わずに画面描画
    if (state.mtgCallback.memberInfoList) {
      navigate("/contract", {
        state: { isSubmit: true },
      });
    } else {

      // トークンが存在しないまたは、リダイレクトトークンと一致しない場合
      if (!oidcState || redirectState !== oidcState) {
        // 認証エラー画面
        navigate("/error", {
          state: { errorCode: 403 },
        });
        return;
      }

      (async () => {
        // API呼び出し
        await getMemberInfo(
          { code: redirectCode, kbn: "shch" },
          (data) => {
            if (data.errorResponse) {
              // 認証エラー
              navigate("/error", {
                state: {
                  errorCode: 401,
                  errorMsg: "会員情報を取得できませんでした。",
                },
              });
            } else {
              memberInfoList = data.memberInfoList.map((item) => {
                return {
                  ...item,
                  fullAddress: getFullAddress(
                    item.address,
                    item.bant,
                    item.go,
                    item.bldName,
                    item.muneban,
                    item.heyaban
                  ),
                  telNo: formatTelNumber(item.telNo),
                  name,
                };
              });

              state.mtgCallback.memberInfoList = memberInfoList;
              state.mtgCallback.mtgLoginSelect = "";

              // oidcState削除
              sessionStorage.removeItem("oidcState");

              navigate("/contract", {
                state: { isSubmit: true },
              });
            }
          },
          // エラー処理
          (e) => {
            console.log(e);
            navigate("/error", {
              state: { errorCode: 500 },
            });
          }
        );
      })();
    }
  }, [
    navigate,
    actions,
    getMemberInfo,
    oidcState,
    redirectCode,
    redirectState,
    state.mtgCallback.memberInfoList,
  ]);

  return <>{
    loading && (
      <div css={[loadingCss]}>
        <ReactLoading type="spin" color="#b5b5b5" height="50px" width="50px" />
      </div>
    )
  }</>
});

export default ContractMtgCallback;
